export { default } from './EResourceBlock';



// WEBPACK FOOTER //
// ./app/components/shared/EResourceBlock/index.js